
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M388.053 357.165l-13.346-13.349c-4.625-4.389-10.026-6.582-16.19-6.582-6.294 0-11.632 2.194-16.021 6.582L256 430.313l-86.494-86.495c-4.39-4.389-9.729-6.583-16.019-6.583-6.169 0-11.568 2.195-16.193 6.583l-13.17 13.35c-4.51 4.505-6.764 9.905-6.764 16.195 0 6.405 2.257 11.745 6.763 16.015l115.858 115.86c4.274 4.507 9.61 6.762 16.019 6.762 6.289 0 11.688-2.255 16.192-6.762l115.86-115.86c4.39-4.391 6.587-9.729 6.587-16.015.002-6.171-2.197-11.567-6.586-16.198zM123.947 154.835l13.346 13.348c4.625 4.389 10.025 6.583 16.19 6.583 6.293 0 11.632-2.195 16.021-6.583l86.494-86.497 86.495 86.495c4.39 4.389 9.729 6.583 16.019 6.583 6.168 0 11.568-2.196 16.193-6.583l13.17-13.35c4.511-4.505 6.764-9.906 6.764-16.195 0-6.406-2.257-11.745-6.763-16.015L272.019 6.762C267.745 2.255 262.409 0 256 0c-6.289 0-11.688 2.255-16.193 6.762l-115.859 115.86c-4.39 4.391-6.587 9.73-6.587 16.015-.002 6.171 2.197 11.568 6.586 16.198z"}})])
          )
        }
      }
    